import {RequestedDocuments} from './requested-documents';

export class RequestDocument {
  caseId: string;
  hashkey: string;
  requiredDocuments: RequestedDocuments;

}
